/**
 * Zone color palette.
 *
 * The legacy scio1 palette (drawing.js:583-593) had pale yellow / cream
 * tones (#fdfcdc, #edf6f9) that made white zone labels unreadable on
 * the canvas. We replaced it with a Tailwind-500 inspired set: all
 * saturated mid-tones at roughly equal lightness, so any white text
 * placed on top hits a WCAG 3:1 contrast ratio. Existing assets keep
 * their saved color (Asset.screenZones[i].color survives the swap);
 * only fresh zones and unsaved templates use this new palette.
 *
 * Ordering puts blue first (matches what most users intuitively expect
 * as "Zone 1" / primary zone) and cycles through hues evenly.
 */
export const SPLIT_SCREEN_PALETTE = [
  '#0ea5e9', // sky-500
  '#10b981', // emerald-500
  '#f59e0b', // amber-500
  '#8b5cf6', // violet-500
  '#ec4899', // pink-500
  '#14b8a6', // teal-500
  '#f97316', // orange-500
  '#6366f1', // indigo-500
  '#84cc16', // lime-500
] as const;

export const SPLIT_SCREEN_OPACITY = 0.9;

export function getRandomColor(): string {
  const letters = '0123456789ABCDEF';
  let out = '#';
  for (let i = 0; i < 6; i++) {
    out += letters[Math.floor(Math.random() * 16)];
  }
  return out;
}

/**
 * Allocate a free color from the palette, falling back to a random one
 * once every palette entry is in use. Mirrors the loop in
 * `drawing.js:addObj()` (lines 683-697).
 */
export function pickZoneColor(used: Iterable<string>): string {
  const taken = new Set(used);
  for (const candidate of SPLIT_SCREEN_PALETTE) {
    if (!taken.has(candidate)) return candidate;
  }
  return getRandomColor();
}
